<template>
  <div class="content">
    <Hero motto="SOME SUPER IMPORTANT STUFF"/>
    <MainSlider/>
    <FirstSection class="first_section"/>
    <SecondSection class="second_section"/>
    <ThirdSection class="third_section"/>
    <FooterSection class="footer"/>
  </div>
</template>

<script>
import Hero from '../components/Hero.vue';
import MainSlider from '../components/MainSlider.vue';
import FirstSection from '../components/FirstSection.vue';
import SecondSection from '../components/SecondSection.vue';
import ThirdSection from '../components/ThirdSection.vue';
import FooterSection from '../components/FooterSection.vue';

export default {
  name: 'Home',
  components: {
    Hero,
    MainSlider,
    FirstSection,
    SecondSection,
    ThirdSection,
    FooterSection
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(to.path === '/about') vm.scrollToSectionFromMenuNewRoute('.second_section')
      else if(to.path === '/projects') vm.scrollToSectionFromMenuNewRoute('.third_section')
    })
  },
  beforeRouteUpdate (to, from, next) {
    if(to.path === '/about') this.scrollToSectionFromMenu('.second_section')
    else if(to.path === '/projects') this.scrollToSectionFromMenu('.third_section')
    next()
  },
  methods:{
     scrollToSectionFromMenu(element){
      document.documentElement.classList.remove('overflow_is_active')
      let el = document.querySelector(element)
      let scrollMinTime = Math.floor(el.offsetTop / 100) / 10
      let scrollTime = Math.max(scrollMinTime, 1)
      TweenLite.to(window, scrollTime, {scrollTo: el, ease: Power2.easeOut, delay: 0.25})
    },
    scrollToSectionFromMenuNewRoute(element){
      document.documentElement.classList.remove('overflow_is_active')
      let el = document.querySelector(element)
      let scrollMinTime = Math.floor(el.offsetTop / 100) / 10
      let scrollTime = Math.max(scrollMinTime, 1)
      TweenLite.to(window, scrollTime, {scrollTo: el, ease: Power2.easeOut, delay: 0.4})
    }
  }
}
</script>

<style lang="scss">
body{
  color: $gray-300;
  font-weight: 500;
}
h1, h2, h3, h4{
  text-transform: uppercase;
  margin: 1rem 0;
}
*{
  &::-moz-selection{
    background: $pale-blue;
  }
  &::selection{
    background: $pale-blue;
  }
}
.icon {
  display: inline-block;
  stroke-width: 0;
  stroke: currentColor;
  fill: currentColor;
  pointer-events: none;
  position: relative;
  z-index: 50;
}
svg{
  pointer-events: none;
}
p{
  text-align: justify;
}
.btn{
  height: 50px;
  width: 50px;
  line-height: 50px;
  border-radius: 50%;
  display: inline-block;
  color: $gray-400;
}
img{
  max-width: 100%;
  height: auto;
}
.overlay{
  pointer-events: none;
  position: absolute;
  width: 60px;
  height: 60px;
  top: 0;
  bottom: 0;
  left: -5px;
  right: 0;
  z-index: 10;
  background-color: lighten($dirty-vel, 14);
  border-radius: 50%;
  transform: translate3d(0, -100%, 0)
}
.border_r{
  border-radius: 4px;
}
.header{
  padding-top: .4rem;
}
#site_content{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}
.first_section, .second_section, .third_section{
  padding-top: 101px;
  padding-bottom: 204px;
  min-height: 100vh;
}
.first_section{
  background-color: lighten($dirty-vel, 25);
}
.second_section{
  background-color: $dirty-vel;
}
.third_section{
  background-color: $dark-vel;
}
.footer{
  padding-top: 101px;
  padding-bottom: 101px;
  background: url(../assets/images/footer-bg.svg) no-repeat;
  background-position: left bottom;
  background-color: #1a0e25;
}
</style>
